import { Transition } from '@headlessui/react';
import { XIcon } from '@heroicons/react/solid';
import { FC, useEffect, useState } from 'react';
import ISessionFormProps from './interface';
import tw, { styled } from 'twin.macro';
import { useForm } from 'react-hook-form';
import CertifyingAuthority from '../../../layout-a/forms/common/Inputs//CertifyingAuthority';
import FirstName from '../../../layout-a/forms/common/Inputs/FirstName';
import LastName from '../../../layout-a/forms/common/Inputs//LastName';
import Email from '../../../layout-a/forms/common/Inputs//Email';
import PhoneNumber from '../../../layout-a/forms/common/Inputs//PhoneNumber';
import SuccessPopup from '../../SuccessPopup';
import MasterClassContainer from '../../container';
import Spinner from '../../../layout-a/components/common/Spinner';
import { EventData } from '../../../../lib/events/constants';
import UpGradSubmitHandler from '../submitHandler';
import MobileVerificationPopUpV2 from '../MobileVerificationV2';

const CloseButton = tw.button`
  border-transparent outline-none
`;

const Container = tw.div`
    w-full  flex 
`;
const ButtonContainer = tw.div`
absolute
top-0
right-0
pt-4
pr-4
`;
const DialogContainer = tw.div`
fixed
inset-0
bg-black
bg-opacity-25
transition-opacity
`;
const Popup = tw.div`
relative
inline-block
bg-white
rounded-t-[3px] 
md:rounded-xl
px-4
pt-5
pb-4
text-left
overflow-hidden
shadow-xl
transform
transition-all
md:my-8
md:pl-1
md:pt-[3px]
md:pb-1
md:pr-[5px]
`;
const PopupContainer = tw.div`
flex
md:items-center
items-end
justify-center
min-h-screen
text-center
`;
const Overlay = tw.div`
      fixed inset-0 bg-black bg-opacity-50 transition-opacity
  `;

const LeftContainer = tw.div`
  hidden md:flex md:w-[387px] bg-[#F3F7FF] px-[28px] pt-[29px] overflow-hidden  flex-col relative
`;

const RightContainer = tw.div`
  md:w-[368px] h-full p-3 md:p-8 bg-white
`;

const TitleContainer = styled.h2(({ align }) => [
  tw`
  font-bold   text-black mb-3 md:mb-4  relative   text-xl leading-[26px] md:text-2xl
    `,
]);

const DescriptionContainer = tw.div`
  md:text-base md:leading-5 text-[14px] leading-5  text-[#333333] md:mb-[31px] mb-[26px]
`;

const FormContainer = tw.form`
    leading-[22px] text-[#444] text-sm
`;

const ContactUsContent = tw.p` 
font-regular 
text-sm 
leading-[21px] 
text-[#666666]
text-center`;

const VerifyButtonContainer = tw.div`
flex 
justify-center 
items-center 
`;
const UpgradSessionPopup: FC<ISessionFormProps> = ({
  isOpen,
  setOpen,
  title,
  description,
  sectionName,
  isOTPVerified,
  webinarDate,
  webinarEndDate,
  webinarId,
  zoomLink,
  instructor,
  classType,
  program,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted },
    reset,
    setValue,
    getValues,
  } = useForm({
    mode: 'onTouched',
  });

  const inputProps = { register, errors, isSubmitted, setValue, getValues };

  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  //const [showBookYouSeatPopUp, setShowBookYouSeatPopUp] = useState(true);
  const [optionalOpen, setOptionalOpen] = useState<boolean>(false);
  const toggleOptional = () => setOptionalOpen(!optionalOpen);

  const [leadData, setLeadData] = useState(0);

  const [pageURL, setPageURL] = useState('');

  const [buttonStatus, setButtonStatus] = useState<boolean>(false);

  // close
  const close = () => {
    setOpen(false);
    setButtonStatus(false);
  };

  useEffect(() => {
    setPageURL(window.location.href);
  }, []);

  const onSubmit = async (data: any) => {
    setButtonStatus(true);
    const eName = EventData[sectionName.replace('click-register', 'submit')]?.name;
    const eLabel = EventData[sectionName.replace('click-register', 'submit')]?.label;
    const eAction = EventData[sectionName.replace('click-register', 'submit')]?.action;
    const extraData = {
      leadType: 'MASTER_CLASS_BOOK_1_1_SESSION',
      static_lead_type: 'MASTER_CLASS_BOOK_1_1_SESSION',
      page: `${pageURL}`,
      action: eAction,
      name: eName,
      label: eLabel,
      program: program,
    };

    const response = await UpGradSubmitHandler(data, extraData, reset);

    if (response) {
      setLeadData(response.response);
      setButtonStatus(false);
      setShowOtpPopup(true);
      setOpen(false);
    }
  };

  return (
    <div className="absolute">
      <Transition.Root show={isOpen}>
        <div className="fixed z-[200] inset-0 overflow-y-auto">
          <MasterClassContainer>
            <PopupContainer className="flex md:items-center items-end justify-center text-center sm:block sm:p-0">
              <Transition.Child
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Overlay onClick={close} />
              </Transition.Child>

              <Transition.Child
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Popup className={`md:w-[763px] w-full -mb-[6px] md:mb-0`}>
                  <ButtonContainer>
                    <CloseButton type="button" onClick={close}>
                      <XIcon className="w-4 hover:text-[#585858]" />
                    </CloseButton>
                  </ButtonContainer>
                  <Container>
                    <LeftContainer>
                      <div className="text-black text-2xl font-bold leading-[31px] max-w-[299px] mb-4">
                        When it comes to your career, nothing should get in the way!
                      </div>
                      <div className=" text-[12px] leading-[18px] font-regular text-black max-w-[290px]">
                        Want to grow in your career faster and in the right direction? You have come to the right place.
                        Get on a 1:1 session with our academic counsellor and get the guidance you need to take the next
                        steps.
                      </div>
                      <div className="absolute right-[-70px] bottom-[-6px] text-center">
                        <img
                          src={'https://d2o2utebsixu4k.cloudfront.net/master-class/Session.png'}
                          width="422"
                          height="374"
                        />
                      </div>
                    </LeftContainer>
                    <RightContainer>
                      <TitleContainer>{title}</TitleContainer>
                      {description && (
                        <DescriptionContainer>
                          <div dangerouslySetInnerHTML={{ __html: description }}></div>
                        </DescriptionContainer>
                      )}
                      <FormContainer onSubmit={handleSubmit(onSubmit)}>
                        <div className="grid md:grid-cols-2  md:items-center">
                          <input className="hidden" type="text" {...register('certifying_authority')} />

                          {/* Certifying authority */}
                          <CertifyingAuthority {...inputProps} />

                          {/* First name */}
                          <FirstName {...inputProps} fullWidth={true} asterisk={true} />

                          {/* Last name */}
                          <LastName {...inputProps} fullWidth={true} asterisk={true} />
                        </div>

                        <div>
                          {/* Email & phone number */}
                          <Email {...inputProps} asterisk={true} fullWidth={true} />
                        </div>

                        {/* Phone Number */}
                        <div>
                          <PhoneNumber {...inputProps} fullWidth={true} asterisk={true} />
                        </div>

                        <button className=" w-full flex justify-center items-center font-bold bg-[#db4144] text-white py-4 text-center md:text-xl md:leading-6 text-sm leading-[19px] rounded-[3px] md:rounded    ">
                          {buttonStatus && <Spinner />}
                          {buttonStatus ? <span className="pl-[2px]">Submitting...</span> : 'Book Session'}
                        </button>
                      </FormContainer>
                    </RightContainer>
                  </Container>
                </Popup>
              </Transition.Child>
            </PopupContainer>
          </MasterClassContainer>
        </div>
      </Transition.Root>

      {showOtpPopup && (
        <MobileVerificationPopUpV2
          title={'Mobile Verification'}
          isOpen={showOtpPopup}
          setOpen={setShowOtpPopup}
          leadData={leadData}
          sectionName={sectionName}
          setShowSuccessPopup={setShowSuccessPopup}
          setShowBookYouSeatPopUp={setOpen}
          webinarDate={webinarDate}
          webinarEndDate={webinarEndDate}
          webinarId={webinarId}
          zoomLink={zoomLink}
          instructor={instructor}
          classType={classType}
          setLeadData={setLeadData}
        />
      )}

      {showSuccessPopup && (
        <SuccessPopup
          contentSelected={true}
          isOpen={showSuccessPopup}
          setOpen={setShowSuccessPopup}
          sectionName={sectionName}
        />
      )}
    </div>
  );
};

export default UpgradSessionPopup;
